import React from "react";
import styles from "./ListCard.module.scss";
import { PanchangDetails, timingsDataType } from "../../Enum";
import { removeUnderscore } from "@/utils/helper";

interface ListCardProps {
  title: string;
  subTitle: string;
  className?: string;
  data: PanchangDetails[];
}

const ListCard = ({ title, subTitle, data, className }: ListCardProps) => {
  const currDate = new Date().toLocaleDateString();
  return (
    <div className={`${styles.listCard} ${className ?? ""}`}>
      <div className={styles.listCardHeader}>
        <h3>{title}</h3>
        <p>{subTitle}</p>
      </div>
      <ul className={styles.listCardDetails}>
        {data.map(({ name, startTime, endTime }, index) => {
          return (
            <li key={index}>
              <h4>{removeUnderscore(name)}</h4>
              <span>
                <p>
                  From {currDate} {startTime}{" "}
                </p>
                <p>To</p>
                <p>
                  {currDate} {endTime}
                </p>
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ListCard;
